export default "__VITE_ASSET__d6533468__"